module.exports = __webpack_public_path__ + "static/media/streetWrong.69e97393.png";